import React, { createContext } from "react";
import { defaultNewPlanningOptions, NewPlanningOptions } from "./types";
import { getNewShowRoute, NewPlanningModal } from "./NewPlanningModal";

interface PlanningContextValue {
  open: (opts: Partial<NewPlanningOptions> | null) => void
  openWithExistingOptions: () => void
  setOpts: (opts: Partial<NewPlanningOptions> | null) => void
  opts: NewPlanningOptions | null
}

const defaultPlanningContext: PlanningContextValue = {
  open: () => { },
  openWithExistingOptions: () => { },
  setOpts: () => { },
  opts: null
};

export const PlanningContext = createContext<PlanningContextValue>(defaultPlanningContext);

export const PlanningProvider = (props: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [options, setOptions] = React.useState<NewPlanningOptions | null>(null);

  const open = (opts: Partial<NewPlanningOptions> | null) => {
    const merged = { ...options, ...opts };
    if (canOnlyAddShow()) {
      window.location.href = getNewShowRoute({ ...defaultNewPlanningOptions, ...merged });
      return;
    }
    setOpts(merged);
    setIsOpen(true);
  }

  const setOpts = (opts: Partial<NewPlanningOptions> | null) => {
    if (opts === null) {
      setOptions(null);
      return;
    }

    setOptions({ ...defaultNewPlanningOptions, ...opts });
  }
  const onClose = () => {
    setIsOpen(false);
  }

  return <PlanningContext.Provider value={{
    open,
    openWithExistingOptions: () => open(options),
    setOpts,
    opts: options
  }}>
    {props.children}
    <NewPlanningModal
      isOpen={isOpen}
      options={options}
      onClose={onClose}
    />
  </PlanningContext.Provider>
}

const canOnlyAddShow = () => {
  return site.permissions.show.canCreate &&
    !site.permissions.flight.canCreate &&
    !site.permissions.train.canCreate &&
    !site.permissions.groundTransport.canCreate &&
    !site.permissions.externalCalendar.canCreate;
}